module.exports = __webpack_public_path__ + "img/box-clouds-3.305b5d15.png";